/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { Card, CardBody, Flex, Heading, Button } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import BreadCrumb from "../../components/breadCrumb";
import { Paths } from "../../routes/paths";
import ReactHookFormDropdown from "../../components/forms/react-hook-dropdown";
import { useLookupCashCenters } from "../../services/lookups-mutations";
import Loader from "../../components/PageLoader";
import { useAddConsumablesBulk } from "../../services/consumables";
import NumericInput from "../../components/forms/react-hook-numeric-input";
import FormInput from "../../components/forms/form-Input";

export default function AddConsumable() {
  const navigate = useNavigate();

  const {
    mutate: getCashCenter,
    data: cashCenterList,
    isPending: gettingCashCenterList,
    // error: cashCenterListError,
  } = useLookupCashCenters();
  const {
    mutate: addConsumable,
    data: addConsumableRes,
    isPending: addingConsumable,
    // error: addConsumableError,
    reset: resetAddConsumable,
  } = useAddConsumablesBulk();

  useEffect(() => {
    getCashCenter();
  }, []);
  useEffect(() => {
    if (addConsumableRes) {
      resetAddConsumable();
      navigate(Paths.consumable);
    }
  }, [addConsumableRes]);
  const {
    handleSubmit,
    control,
    // getValues,
    formState: { errors },
  } = useForm({
    defaultValues: {
      cashCenterId: "",
      consumableType: "",
      serialPrefix: "",
      serial: "",
      quantity: 0,
    },
  });

  const generalFieldProps = { errors, control };
  const formValidationRules = {
    cashCenterId: { required: "Please select cash center" },
    consumableType: { required: "Please select consumable type" },
    // serialPrefix: { required: "Please add prefix" },
    serial: {
      required: "Please add serial",
      pattern: { value: /^[0-9\s]+$/, message: "Only numbers are allowed" },
    },
    quantity: {
      required: "Please add quantity",
      validate: (value) => {
        if (!value || value === "0") return "Please add quantity";
        return true;
      },
    },
  };

  const makeConsumableArray = (data) => {
    const digitsCount = `${data.quantity}`.length;
    const serials = [];
    for (let i = 0; i < data.quantity; i++) {
      const startSerial = Number(data.serial) + i;
      const zeroCount = digitsCount - `${startSerial}`.length;
      serials.push({
        serial: `${data.serialPrefix}${
          zeroCount > 0 ? "0".repeat(digitsCount - `${startSerial}`.length) : ""
        }${startSerial}`,
      });
    }
    const payload = {
      cashCenterId: data.cashCenterId || "",
      consumables: serials.map((elm) => ({
        description: data.consumableType,
        sealNo: elm.serial,
      })),
    };

    addConsumable(payload);
  };

  return (
    <>
      {gettingCashCenterList || addingConsumable ? <Loader /> : <></>}

      <div className="form-container">
        <BreadCrumb
          links={[
            { text: "Consumable", link: Paths.consumable },
            { text: "Add Consumable", isCurrentPage: true },
          ]}
        />
        <Flex w="100%">
          <Card flexDirection="column" w="100%">
            <CardBody>
              <Heading>Add Consumable Bulk</Heading>
              <form
                onSubmit={handleSubmit(makeConsumableArray)}
                className="add-location-form"
              >
                <ReactHookFormDropdown
                  {...generalFieldProps}
                  isRequired
                  label="Cash Center"
                  name="cashCenterId"
                  data={cashCenterList?.data.map(item => ({ value: item.cashCenterId, label: item.name })) || []}
                  placeholder="Select Cash Center"
                  rules={formValidationRules.cashCenterId}
                />
                <ReactHookFormDropdown
                  {...generalFieldProps}
                  isRequired
                  label="Consumable Type"
                  name="consumableType"
                  data={[
                    {
                      value: "Pouch Bag",
                      label: "Pouch Bag",
                    },
                    {
                      value: "Security Seal",
                      label: "Security Seal",
                    },
                  ]}
                  placeholder="Select Consumable Type"
                  rules={formValidationRules.consumableType}
                />
                <FormInput
                  {...generalFieldProps}
                  name="serialPrefix"
                  label="Serial Prefix"
                  // rules={formValidationRules.serialPrefix}
                />
                <FormInput
                  {...generalFieldProps}
                  isRequired
                  name="serial"
                  label="Starting Serial"
                  rules={formValidationRules.serial}
                />
                <NumericInput
                  {...generalFieldProps}
                  isRequired
                  name="quantity"
                  label="Quantity"
                  rules={formValidationRules.quantity}
                />
                <Flex w="100%" justify="flex-end" flexDirection="row">
                  <Button type="submit">Add</Button>
                </Flex>
              </form>
            </CardBody>
          </Card>
        </Flex>
      </div>
    </>
  );
}
